<template>
  <div class="hv-referrer-popup" v-if="referrerId && showPopUpId >= 0 && !isShopBuilder">
      <div class="modal fade" id="NotifiyPopUp" tabindex="-1" role="dialog" aria-labelledby="notifiyPopUp" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">{{ $translate("ZeitloungeTheme::Template.popUpReferrerModal" + showPopUpId + "ModalTitle") }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="article" id="content">
                <h2>{{ $translate("ZeitloungeTheme::Template.popUpReferrerModal" + showPopUpId + "ContentTitle") }}</h2>
                <div v-html="$translate('ZeitloungeTheme::Template.popUpReferrerModal' + showPopUpId + 'ContentHtmlText')"></div>
              </div>      
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
    name: "referrer-popup",
    props: {
      referrerId: {
        type: Number
      }
    },
    data () {
      return {
        showPopUpId: -1
      }
    },
    mounted () {
      this.checkReferrer();
    },
    computed:
    {
        isShopBuilder()
        {
          return App ? App.isShopBuilder : false;
        }
    },
    methods: {
      checkReferrer () {
        if(this.referrerId) {
          for(var i = 1; i <= 5; i++) {

            let settingReferrer = Number(this.$translate("ZeitloungeTheme::Template.popUpReferrerModal"+ i +"ReferrerId"));

            if(settingReferrer && settingReferrer === this.referrerId) {
              this.showPopUpId = i;
              break;
            }
          }
          setTimeout(() => {
            this.showPopUp(this.showPopUpId);
          }, 5000);
        }
      },
      showPopUp (popUpId) {
        if(this.getCookie("NotifPopUp" + popUpId) != "Showed") {
          $('#NotifiyPopUp').modal('show');
          this.setCookie("NotifPopUp" + popUpId, "Showed", 1);
        }
      },
      setCookie (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      },
      getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }
    }
}
</script>
